<template>
  <div class="">
    <delivery-form title="ساخت نرخ" :submitFunction="createDelivery"/>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import DeliveryForm from './DeliveryForm'

export default {
  name: "CreateDelivery",
  components: {DeliveryForm},
  methods: {
    ...mapActions({
      createDelivery: "Delivery/createDelivery"
    })
  }
}
</script>

<style scoped>

</style>